// 导入组件
import Hello from './hello';
import Message from './message';
import SystemGuide from './system-guide';
import Popover from './popover';
import IconSvg from './icon-svg';
import Image from './image';
import Grid from './grid';
import Drawer from './drawer'
// 未做改动，暂先注释
// import Tooltip from './Tooltip';
import Tag from './tag';
import BaseSelect from './base-selector';
import PageFilter from './page-filter';
import TopFilter from './top-filter';

import './app.scss';
import './dap.scss';

import * as PACKAGE from '../package.json';

// 存储组件列表
const components = [
    Hello,
    Message,
    SystemGuide,
    Popover,
    IconSvg,
    // Tooltip,
    Tag,
    PageFilter,
    TopFilter,
    ...BaseSelect,
    Image,
    Grid,
    Drawer
];

// 定义 install 方法，接收 Vue 作为参数。
// 如果使用 use 注册插件，则所有的组件都将被注册
const install = function (Vue) {
    // 判断是否安装
    if (install.installed) return;
    // 遍历注册全局组件
    components.forEach(component => {
        Vue.component(component.name, component);
    });
    // Vue.prototype 全局属性
    // Vue.prototype.$message = Message;

    // 注册指令
    Vue.directive('dap-popover', Popover.directive);
}

const plugin = {
    version: PACKAGE.version,
    // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
    install,
    // 以下是具体的组件列表
    ...components,
}

// 判断是否是直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default plugin;
